import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/layouts/login.vue").then(m => m.default || m))
}